import { ILookupModel } from '../../interfaces/ILookup';
import { ResizableDialog } from '../shared/ResizableDialog';
import { SelectedRoleRights } from './SelectedRoleRights';

interface IProps {
    open: boolean;
    title: string;
    selectedRoleRights: ILookupModel[];
    onClose: () => void;
}

export const SelectedRoleRightsDialog = ({ open, title, selectedRoleRights, onClose }: IProps) => {
    return (
        <ResizableDialog
            isShowingModal={open}
            title={title}
            defaultHeight={500}
            defaultWidth={450}
            minWidth={450}
            bodyComponent={<SelectedRoleRights selectedRoleRights={selectedRoleRights} />}
            cancelText="Ok"
            handleClose={onClose}
            closeButtonClassName="btn btn-default"
        />
    );
};
